module.exports = __webpack_public_path__ + "static/media/IW.38d748ff.png";